import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { useEffect, useState } from "react";
import { authorizeToCustomRest } from "../../../../features/customAuth/customAuth";
import { defineCustomTableColumns, lazyFetchCustomTableData, fetchCustomTableObjectTypeDataCount, prepareQueryArgsForCustomTableFetch, saveCustomTableStateWebStorage, fetchCustomTableData } from "../customTableObjectType/customTableObjectTypeFunctions";
import { configureTableLazyState, defineTableFilters, TableEvents, tableStateModifyHandle } from "../../../../widgets/table/tableFeatures/tableFunctions";
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper";
import TableWidget from "../../../../widgets/table/tableWidget/TableWidget";
import { getBasicTablePaginator } from "../../../../widgets/table/tableFeatures/tableTemplates/tablePaginatorTemplates";
import { prepareTableData } from "../../../../features/dataFormatFunctions/dataFormatter";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../../../stateManagement/reducers";
import ToastMessageContainer from "../../../../widgets/toastMessageContainer/ToastMessageContainer";

export default function CustomTableDocuments() {
    const dispatch = useDispatch()
    const urlParams = useParams()
    const { id, objectType, entityId: objectId }: any = urlParams
    const [name, setName] = useState<any>(null)
    const [columns, setColumns] = useState<any>(null)
    const [tableState, setTableState] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const [dataCount, setDataCount] = useState<number>(0)
    const [tableDataIsLoading, setTableDataIsLoading] = useState<boolean>(true)
    const [isErrorTableStructure, setIsErrorTableStructure] = useState<boolean>(false)
    const [paginator, setPaginator] = useState<any>({})
    const [paginatorPageInputTooltip, setPaginatorPageInputTooltip] = useState<any>('Введите номер страницы.')
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)
    const objectDocuments = useAppSelector(state => state.customObjectDocuments.documents)
    const currentConfig = getItemWebStorage('currentConfig')
    const { cardAdditionalItems } = currentConfig
    const cardAdditionalItem = cardAdditionalItems.find((item: any) => item?.id === id)

    useEffect(() => {
        const { documents, openDataOptions: restAuthRequestOptions } = cardAdditionalItem ?? {}
        if (restAuthRequestOptions && !restAuthToken) {
            authorizeToCustomRest(restAuthRequestOptions)
        }
        const title = documents?.title
        title ? setName(`${title}`) : setName('...')
    }, [objectType])

    async function defineTableColumns() {
        const { documents, openDataOptions: restAuthRequestOptions, api, apiType } = cardAdditionalItem ?? {}
        const { structure } = documents ?? {}
        if (structure) {
            let columnsStructure: any = structure?.columns
            let columns = await defineCustomTableColumns(columnsStructure, api, restAuthToken, restAuthRequestOptions, apiType)
            let filters = defineTableFilters(columns)
            setColumns(columns)
            setTableState(getItemWebStorage("customTablesState")?.[`${objectType}-documents`] ?? configureTableLazyState({ filters }))
        } else {
            setIsErrorTableStructure(true)
        }
    }

    async function getTableValueAndCount() {
        setTableDataIsLoading(true)
        const { documents, openDataOptions: restAuthRequestOptions, api } = cardAdditionalItem ?? {}
        const { documents: documentsApi, documentsCount: documentsCountApi } = api ?? {}
        let tableData
        if (objectDocuments) {
            tableData = prepareTableData(objectDocuments, columns)
        } else if (documentsApi) {
            const { propertyForEntityIdFilter, propertyForDocuments } = documents ?? {}
            if (propertyForEntityIdFilter) {
                let { sort, filter, offset }: any = prepareQueryArgsForCustomTableFetch(tableState, columns)
                const documentsFilter = {
                    property: propertyForEntityIdFilter,
                    operator: "=",
                    value: objectId
                }
                filter.conditions.push(documentsFilter)
                let { tableData: objectDocuments }: any = await lazyFetchCustomTableData(documentsApi, restAuthToken, 100, offset, sort, filter, restAuthRequestOptions)
                tableData = prepareTableData(objectDocuments, columns)
                let dataCount = await fetchCustomTableObjectTypeDataCount(documentsCountApi, restAuthToken, filter, restAuthRequestOptions)
                setDataCount(dataCount)
            } else if (propertyForDocuments) {
                let { tableData: objectDocuments }: any = await fetchCustomTableData(documentsApi, restAuthToken, restAuthRequestOptions, objectId) ?? {}
                tableData = objectDocuments?.[propertyForDocuments]
                tableData = prepareTableData(tableData, columns)
            }
        }
        setTableData(tableData)
        setTableDataIsLoading(false)
    }

    useEffect(() => {
        if (restAuthToken && !columns) {
            defineTableColumns()
        }
    }, [restAuthToken, columns])

    useEffect(() => {
        if (restAuthToken && columns) {
            getTableValueAndCount()
        }
    }, [restAuthToken, columns, tableState])

    useEffect(() => {
        const paginatorTemplate = getBasicTablePaginator(paginatorPageInputTooltip, setPaginatorPageInputTooltip, tableState, setTableState, dataCount, objectType)
        setPaginator(paginatorTemplate)
    }, [dataCount, tableState, paginatorPageInputTooltip])

    const onSort = (state: any) => tableStateModifyHandle(state, TableEvents.sort, setTableState, `${objectType}-documents`)
    const onPage = (state: any) => tableStateModifyHandle(state, TableEvents.page, setTableState, `${objectType}-documents`)
    const onFilter = (state: any) => tableStateModifyHandle(state, TableEvents.filter, setTableState, `${objectType}-documents`)

    useEffect(() => {
        if (isErrorTableStructure) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error" }))
        }
    }, [isErrorTableStructure])

    return (
        <>
            <ContentHeader title={name} />
            <div className="table-widget-with-toast with-content-header">
                <ToastMessageContainer/>
                <LoaderWrapper isLoading={tableDataIsLoading} >
                    <TableWidget
                        tableValue={tableData}
                        tableState={tableState}
                        columns={columns}
                        onRowSelect={() => { }}
                        dataCount={dataCount}
                        canBeFiltered={false}
                        paginatorTemplate={paginator}
                        pageSize={100}
                        onPage={onPage}
                        onSort={onSort}
                        onFilter={onFilter}
                        type="custom"
                        isLazy={true}
                    />
                </LoaderWrapper>
            </div >
        </>
    )
}

